import React from 'react';
import Select from 'react-select';
import { FaTimes } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../../util/Constants';
import FieldCity from '../common/FieldCity';
import FieldController from '../../controller/FieldController';

class FilterCity extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type);
    let condition = filter ? filter.condition : FieldController.In;
    condition = this.conditions.find(item => condition === item.value);
  
    this.cities = reactLocalStorage.getObject(Const.Cities);
    const cities = this.cities.filter(city => 
      filter && filter.value.includes(`${Const.Opt}${city.value}${Const.Opt}`));
    this.state = { condition: condition, cities };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.In;
      condition = this.conditions.find(item => condition === item.value);
      const cities = this.cities.filter(city => 
        filter && filter.value.includes(`${Const.Opt}${city.value}${Const.Opt}`));
      this.setState({ ...this.state, condition: condition, cities });
    }
  }

  onConditionChanged = select => {
    this.setState({ ...this.state, condition: select });
    if(select.value === FieldController.Empty || select.value === FieldController.NotEmpty) {
      this.props.onValueChange(this.props.field.fieldKey, select.value, '', this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.fieldKey, this.props.field.model_key);
    }
  }

  onOptionChange = selected => {
    let tmp  = '';
    for(let i = 0; i < selected.length; i++) { tmp = tmp + selected[i].value + '~'; }
    tmp = tmp !== '' ? '~' + tmp : '';
    if(tmp !== '') {
      this.props.onValueChange(this.props.field.fieldKey, this.state.condition.value, tmp, this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.fieldKey, this.props.field.model_key);
    }
    this.setState({ ...this.state, cities: selected });
  }

  render() {
    const condition = this.state.condition ? this.state.condition.value : '';
    const isFilter = (this.state.cities && this.state.cities.length > 0)
      || !FieldController.showSelect(Const.MultiSelect, condition);
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">
              {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className={`col-md-${isFilter ? 5: 7}`}>
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
          { isFilter ? <div className="col-md-1"><FaTimes 
            onClick={() => this.props.resetFilter(this.props.field.field_key)}/></div> : null }
        </div>

        <div className="row pt-2">
          { FieldController.showSelect(Const.MultiSelect, condition) ?
            <div className="col-md-12">
              <FieldCity defaultValue={this.state.cities} cities={this.cities}
                onCitySelected={this.onOptionChange} selectionLimit={10} isMulti={true} />
            </div> : null
          }
        </div>
        <hr />
      </>
    );
  }
}


export default FilterCity;